<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <a v-on:click="cerrar" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">exit_to_app</i>
        <p>Cerrar Session</p></a
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
  },
  methods: {
    cerrar() {
      localStorage.removeItem("usertoken");
      location.reload();
    }
  }
};
</script>
